import { NgModule } from '@angular/core';
import { DisallowAccessByRolesPipe } from './disallow-access-by-roles.pipe';
import { DisallowRoutesByRolesPipe } from './disallow-routes-by-roles.pipe';
import { DisallowRoutesByRolePipe } from './disallow-routes-by-role.pipe';

@NgModule({
  declarations: [DisallowAccessByRolesPipe, DisallowRoutesByRolesPipe, DisallowRoutesByRolePipe],
  exports: [DisallowAccessByRolesPipe, DisallowRoutesByRolesPipe, DisallowRoutesByRolePipe],
})
export class AccessByRolePipesModule {}
